import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--kyra-bg)" }}>
        <div className="text-center">
          <div
            className="inline-block mb-3"
            style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontWeight: 900,
              fontSize: 24,
              letterSpacing: 3,
              color: "var(--kyra-gr)",
            }}
          >
            KYR<span style={{ color: "var(--kyra-rd)", fontStyle: "italic" }}>A</span>
          </div>
          <p className="text-sm font-light" style={{ color: "var(--kyra-mu)" }}>
            Chargement...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
